import React from 'react';
import Slider from '../components/Slider';
import OtherHomeSection from './OtherHomeSection';

function Home() {
  return (
    <>
      <Slider />
      <OtherHomeSection />
    </>
  );
}

export default Home;